import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Form, SubmitButton, useForm } from '../../Form2';
import { Form2Modifier } from '../../Form2/Form';

type PageLockForceReleaseFormProps = { forcePageLockReleaseUrl: string };

export function PageLockForceReleaseForm({ forcePageLockReleaseUrl }: PageLockForceReleaseFormProps) {
  const { t } = useSonTranslation('PageLockedModal');
  const navigate = useNavigate();

  const { formProps, fetchState } = useForm({ form: { url: forcePageLockReleaseUrl, method: 'POST', params: [] } });

  useEffect(() => {
    if (fetchState.type === 'success' && fetchState.response.data) {
      navigate(fetchState.response.data.url);
    }
  }, [fetchState, navigate]);

  return (
    <Form id="page-lock-force-release" {...formProps} modifier={Form2Modifier.NO_PADDING}>
      <SubmitButton
        buttonLabel={t('pageLockForceRelease.buttonLabel')}
        messageSuccess={t('pageLockForceRelease.success')}
        messageSending={t('pageLockForceRelease.sending')}
        messageFail={t('pageLockForceRelease.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}
